import { render, staticRenderFns } from "./DsAudienceCTA.vue.js?vue&type=template&id=0cc70a88&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DsAudienceCTA.vue?vue&type=template&id=0cc70a88&scoped=true"
import script from "./DsAudienceCTA.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DsAudienceCTA.vue?vue&type=script&lang=js"
export * from "./DsAudienceCTA.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DsAudienceCTA.vue?vue&type=script&lang=js"
import style0 from "./DsAudienceCTA.vue.scss?vue&type=style&index=0&id=0cc70a88&prod&lang=scss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DsAudienceCTA.vue?vue&type=style&index=0&id=0cc70a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc70a88",
  null
  
)

export default component.exports